export const metatagipogoda = {
  Page: {
    "meta-tagi": {
      Title:
        "Prognoza pogody i klimat – sprawdź gdzie i kiedy jechać na wakacje!",
      Description:
        "Aktualne warunki i prognoza pogody dla miejscowości wakacyjnych w 58 krajach. Opis klimatu – sprawdź gdzie i kiedy jechać! ::: Zaplanuj idealne wakacje z Grupą Portali TravelOne.pl!",
      Keywords: []
    }
  }
};
